import angular from "angular";

angular
    .module('ui-sentinel.relay')
    .config(routes);

routes.$inject = ['$stateProvider'];

function routes($stateProvider) {
    $stateProvider
        .state('relay', {
            abstract: true,
            url: '/relay',
            template: '<ui-view/>',
            data: {
                authorizationRequired: true,
                pageTitle: 'Relay',
                subTitle: null,
                parentState: null
            }
        })
        // Each page carries its own whole heading rather than sharing a parent and a subtitle.
        // Hardly anyone can reach both - editing is limited to a named allowlist while the trail is
        // open to any admin - so a shared "Manage Relay /" prefix would only read as hierarchy to
        // the few people who see the pair, and would put "Manage" on a read-only page for everyone
        // else. "Manage Relay" matches how every other page under Manage titles itself.
        .state('relay.admin', {
            url: '/admin',
            template: require('./relay-admin-list.html'),
            data: {
                pageTitle: 'Manage Relay'
            }
        })
        // The identifier is optional and arrives from the relay badge on the device list, so a
        // badge can be followed straight to that device's history.
        .state('relay.audit', {
            url: '/audit?imei',
            template: require('./relay-audit-list.html'),
            data: {
                pageTitle: 'Relay Audit Trail'
            }
        });
}
